module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-02-2eed9695361597cb65c6d20aa4e8e1e7.svg";